import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as ScrollToTopIcon } from 'assets/common/scrollToTop.svg';
import { AnimatePresence, motion } from 'framer-motion'
import { goToTop } from "components/function";
import { formAxios2 } from "components/axios";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    const [chatOpen, setChatOpen] = useState<boolean>(false);
    const [context, setContext] = useState<string>('');
    const [messages, setMessages] = useState<any>([]);
    const [once, setOnce] = useState<boolean>(false);
    const lastBotMessageRef = useRef<HTMLDivElement | null>(null);
    const [isSolom, setIsSolom] = useState<boolean>(false)
    const [chatId, setChatId] = useState<number>(-1);

    const [showIcon, setShowIcon] = useState<boolean>(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);


    useEffect(() => {
        if (pathname.includes('solomonShip')) {
            setIsSolom(true)
            setChatId(-1);
            setMessages([])
        }
        else {
            setIsSolom(false)
        }
    }, [pathname]);

    useEffect(() => {
        const lastMessage = messages[messages.length - 1];
        if (lastMessage?.role === "model") {
            lastBotMessageRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages, chatOpen]);

    // const close = () => {
    //     setChatOpen(false)
    // }

    // const send = async () => {
    //     if (!context || once) return
    //     setOnce(true)

    //     try {
    //         const newMessages = [
    //             {
    //                 role: 'user',
    //                 message: context,
    //             },
    //         ];
    //         setMessages((prev: any) => [...prev, ...newMessages]);
    //         (chatId && chatId > 0) ?
    //             sendReply() :
    //             sendMessage();
    //     } catch (error) {
    //         console.error('API 오류:', error);
    //         setOnce(false)
    //     }
    // };

    useEffect(() => {
        const handleScroll = () => {
            const vh = window.innerHeight;
            const scrollY = window.scrollY;

            // 1. body가 100vh보다 긴지 확인
            const isLong = document.body.scrollHeight > vh;

            // 2. 20vh 이상 스크롤 시 showIcon = true
            if (isLong) {
                setShowIcon(scrollY > vh * 0.2);
            } else {
                setShowIcon(false);
            }
        };

        // 처음 mount 시 바로 체크
        handleScroll();

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const sendMessage = () => {
        if (!context) return

        const formData = new FormData();

        formData.append('roomId', '')
        formData.append('userMessage', context)

        formAxios2.post('chat/start', formData).then(res => {
            if (res.data.code === 200) {
                setChatId(res.data.data.roomId)
                const newMessages = [
                    {
                        role: 'model',
                        message: res.data.data.message,
                    },
                ];

                setMessages((prev: any) => [...prev, ...newMessages]);
                setContext('')
            }
        }).finally(() => {
            setOnce(false)
        })
    }

    const sendReply = () => {
        if (!context) return

        const formData = new FormData();

        formData.append('roomId', String(chatId))
        formData.append('userMessage', context)

        formAxios2.post('chat/reply', formData).then(res => {
            if (res.data.code === 200) {
                const newMessages = [
                    {
                        role: 'model',
                        message: res.data.data.message,
                    },
                ];

                setMessages((prev: any) => [...prev, ...newMessages]);
                setContext('')
            }
        }).finally(() => {
            setOnce(false)
        })
    }

    return (
        <AnimatePresence>
            {showIcon && (
                <div className="right-5 bottom-5 z-50 fixed cursor-pointer">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                    >
                        <div className="flex flex-col justify-center items-center bg-black rounded-full text-white text-xs">
                            <div
                                className="flex flex-col justify-center items-center gap-1 w-20 tablet:w-12 h-20 tablet:h-12"
                                onClick={goToTop}
                            >
                                <ScrollToTopIcon className="tablet:w-6" />
                                <p className="tablet:hidden">위로이동</p>
                            </div>
                            {/* <div
                                className="flex flex-col justify-center items-center gap-1 w-20 tablet:w-12 h-20 tablet:h-12"
                                onClick={() => {
                                    setChatOpen(true)
                                }}
                            >
                                <Chat className="tablet:w-6" />
                                <p className="tablet:hidden">대화하기</p>
                            </div> */}

                        </div>
                    </motion.div>
                </div>
            )}

            {/* <AnimatePresence key={'chatArea'}>
                {chatOpen && (
                    <div
                        className="top-0 right-0 z-[100] fixed flex justify-end items-end bg-[rgba(0,0,0,0.3)] p-5 w-full h-dvh"
                        onClick={() => {
                            setChatOpen(p => !p)
                        }}
                    >
                        <motion.div
                            className='flex flex-col bg-[#F8F8FA] rounded-xl w-[500px] tablet:w-full h-[700px] tablet:max-h-[80vh] overflow-hidden'
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.2 }}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <div className="relative flex justify-center items-center p-4">
                                <p className="font-semibold text-lg">SolomonShip AI</p>
                                <Close
                                    className='right-4 absolute cursor-pointer'
                                    onClick={() => {
                                        close();
                                    }}
                                />
                            </div>
                            <div className="flex flex-col flex-1 gap-2 px-4 overflow-y-auto">
                                <div className="flex justify-center items-center bg-white p-4.5">
                                    솔로몬쉽은 물류운송과 관련된 모든 정보를 AI기반으로 예측, 요약하여 고객에게 제공하는 프로그램입니다.
                                </div>
                                {
                                    messages.length > 0 &&
                                    messages.map((m: any, idx: number) => {
                                        const isLastBot = m.role === "user" && idx === messages.length - 2;
                                        return (

                                            <div className={`flex w-full ${idx === messages.length - 1 ? 'mb-10' : ''}`} key={idx}>
                                                {
                                                    m.role !== "user" &&
                                                    <InnerLogo />
                                                }
                                                <div className={`flex w-full ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                                                    {
                                                        m.role !== "user" &&
                                                        <Left className="mt-3 ml-2" />
                                                    }
                                                    <div
                                                        ref={isLastBot ? lastBotMessageRef : null}
                                                        className={`${m.role === "user" ? "bg-primary text-white rounded-tr-none" : "bg-white rounded-tl-none mt-3"} rounded p-4 max-w-9/10 `}
                                                    >
                                                        <ReactMarkdown>
                                                            {m.message}
                                                        </ReactMarkdown>
                                                    </div>
                                                    {
                                                        m.role === "user" &&
                                                        <Right />
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div className="flex items-center gap-3 bg-white p-5">
                                <div className="flex-1">
                                    <CustomInput
                                        className="!rounded-full"
                                        fontSize="base"
                                        type="text"
                                        disabled={once}
                                        value={context}
                                        placeholder="무엇이든 물어보세요"
                                        onChange={(e) => {
                                            setContext(e.target.value)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                send();
                                            }
                                        }}
                                    />
                                </div>
                                <Send
                                    fill={context ? '#196BFF' : '#9D9EB7'}
                                    onClick={() => {
                                        if (!once) {
                                            send()
                                        }
                                    }}
                                />
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence> */}
        </AnimatePresence>
    )
};